/**
 * Formatuje błąd do tekstu
 *
 * @export
 * @param {{graphQLErrors?: {message?: string}[]}} [err]
 * @returns {string}
 */
export function formatError(err) {
    return ((err && err.graphQLErrors && err.graphQLErrors[0] && err.graphQLErrors[0].message) ||
        'Wystąpił błąd. Spróbuj ponownie później.');
}
//# sourceMappingURL=formatError.js.map